export enum ProductCheckListDataTestIds {
    title = 'pcl-title',
    productsClaimedByAge = 'pcl-stat-claim-by-age',
    productsClaimedByHour = 'pcl-stat-claim-by-hour',
    cellActions = 'pcl-cell-actions',
    cellGuests = 'pcl-cell-guests',
    cellNotes = 'pcl-cell-notes',
    cellOwner = 'pcl-cell-owner',
    cellProducts = 'pcl-cell-products',
    cellResource = 'pcl-cell-resource',
    cellTotal = 'pcl-cell-total',
    guest = 'pcl-guest',
    product = 'pcl-product',
    total = 'pcl-total',
    claimed = 'pcl-claimed',
}
